/* eslint-disable */
import React, { Component } from 'react';
import { WhiteSpace, WingBlank, Toast, List, NoticeBar, Modal } from 'antd-mobile';
import TextEl from './component/Text';
import LongText from './component/LongText';
import Email from './component/Email';
import PhoneNumber from './component/PhoneNumber';
import CheckboxGroup from './component/CheckboxGroup/index';
import Url from './component/Url';
import ButtonEl from './component/Button';
import SignIn from './component/SignIn';
import Image from './component/Image/index';
import FileAttachment from './component/FileAttachment/index';
import SubmitResult from './component/SubmitResult';
import ImageCode from './component/ImageCode/index';
import Location from './component/Location/index';
import ImageCodeModal from './component/ImageCode/ImageCodeModal';
import Country from './component/Address/Country';
import Province from './component/Address/Province';
import City from './component/Address/City';
import District from './component/Address/District';
import CountryOld from './component/AddressOld/Country';
import ProvinceOld from './component/AddressOld/Province';
import CityOld from './component/AddressOld/City';
import DistrictOld from './component/AddressOld/District';
import MultiLevelSelectOne from './component/MultiLevelSelectOne';
import Signature from './component/Signature/index';
import NumberEl from './component/Number/index';
import Currency from './component/Number/Currency';
import Percentile from './component/Number/Percentile';

import DateElement from './form/date';
import Time from './form/time';
import DateTime from './form/datetime';
import Select from './form/select/index';
import i18nConfig from "./assets/i18n"

import './assets/style.less';
import './assets/date-time-picker.less';

import postData, { calPaymentAmount, getPayResult } from './assets/xhr';
import model from './assets/model';

import createDOMForm from 'rc-form/lib/createDOMForm';
import jrQrcode from 'jr-qrcode';
const isMobile = /Android|iPhone|iPod|iPad/i.test(navigator.userAgent);
const isMobileBrowser = isMobile && !/MicroMessenger|AlipayClient|FSBrowser/i.test(navigator.userAgent);
const TypeToComponent = {
    text: TextEl,
    long_text: LongText,
    true_or_false: Select,
    select_one: Select,
    select_many: CheckboxGroup,
    number: NumberEl,
    currency: Currency,
    date: DateElement,
    time: Time,
    date_time: DateTime,
    image: Image,
    email: Email,
    phone_number: PhoneNumber,
    url: Url,
    file_attachment: FileAttachment,
    location: Location,
    country: Country, //国家省市区
    province: Province,
    city: City,
    district: District,
    country_old: CountryOld,
    province_old: ProvinceOld,
    city_old: CityOld,
    district_old: DistrictOld,
    percentile: Percentile,
    multi_level_select_one: MultiLevelSelectOne,
    signature: Signature
}
isMobile && Object.assign(TypeToComponent, { group: SignIn });

const UA = typeof window !== 'undefined' && window.navigator.userAgent.toLowerCase()
const isWXBrowser = UA.toLowerCase().indexOf('micromessenger') !== -1
const isAndroid = (UA && UA.indexOf('android') > 0)
const isFSAdrBrowser = !isWXBrowser && /FSBrowser\/((\d+.?)+)/i.test(UA) && isAndroid

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayName: '',
            error: false,
            message: '',
            components: [],
            buttons: [],
            submitResult: false,
            isPay: false,
            verifyCode: null,
            timeCode: -1,          //验证码刷新
            payment_data: {},      // 支付组件相关对象，形式同于calculate接口请求的data {api_name1: value1, api_name2: value2, ...}
            payment_obj: {},        // 支付组件相关对象，形式同于calculate接口返回的calculateResult {api_name: value}
            selectedCountry: null,
            selectedProvince: null,
            selectedCity: null,
            selectedDistrict: null,
            isRenderLang: false,
            isOldAddress: true
        }
    }
    componentWillMount() {

        // 请求表单数据
        Toast.loading('Loading...', 0); // 10s 一直等到接口返回

        let postdata = postData({
            url: "/smartform/rest/extApi/describe/detail",
            data: JSON.stringify({
                cardId: model.cardId
            }),
            callback: (response) => {
                Toast.hide();

                const { code, message, data } = response;
                let describe = data && data.describe || {}
                let langData = data && data.langData || i18nConfig || {}
                let lang =  describe.lang || 'zh-CN'
                let tenantId = describe.tenantId
                this.setLang(lang)
                this.setLanguege(langData)
                this.setTenantId(tenantId)
                // this.setLanguageData(i18nConfig)
                this.setState({
                    isOldAddress: data && !data.isV3
                });
                this.setState({
                    isRenderLang: true
                });
                let error = code !== 0;  // 接口是否正确
                if (error) {
                    this.setState({
                        error,
                        message
                    });
                    return;
                }

                sessionStorage.setItem('x-fs-sf-token', postdata.getResponseHeader('x-fs-sf-token'));
                this.formatData(data);
            },
            error: (response) => {
                Toast.hide();
                let message = $st('获取表单失败，请检查网络');
                if (response && response.message) {
                    message = response.message;
                }
                this.setState({
                    error: true,
                    message
                })
            }
        })


    }
    
    setLang = (lang = 'zh-CN') => {
        window.sLanguageType = lang
    }

    setLanguege = (languegeData = {}) => {
        window.$st = function(data) {
            if(data) {
                let type = window.sLanguageType || 'zh-CN'
                return languegeData[data] || data
            }
            return data
        }
    }

    setTenantId = (id) => {
        window.tenantId = id
    }

    formatData = (data) => {
        let { describe, layout, data: default_values = {} } = data;

        // fields
        let { fields, display_name: displayName, description, is_show_captcha } = describe;
        let components = layout.components[0];

        let buttons = components.buttons;
        let sections = components.field_section[0];
        let formFields = sections.form_fields;

        // 1. 级联字段处理，需要顾虑国家省市区
        let arr = [];
        formFields.forEach((item, index) => {
            let field = fields && fields[item.field_name];
            if (!field) { //意外，测试时发现
                return;
            }
            let parent = field.cascade_parent_api_name && fields[field.cascade_parent_api_name];

            if (parent) { //级联选择列表
                field.parent_node = parent;
                if (!parent.child_node) {
                    parent.child_node = []
                }
                parent.child_node.push(field);
            }
            //TODO 处理 group 组件

            field.is_required = item.is_required;
            field.is_readonly = item.is_readonly;

            // 设置默认值
            let apiName = field.api_name;
            if (typeof default_values[apiName]) {
                field['default_value'] = default_values[apiName];
                //如果是国家省市区字段且有默认值，需要设置默认值
                if(['country', 'province', 'city', 'district'].includes(field.type)){
                    this.setState({
                        [`selected${field.type.charAt(0).toUpperCase() + field.type.slice(1)}`]: {
                            [apiName]: field['default_value'],
                            ...this.state[`selected${field.type.charAt(0).toUpperCase() + field.type.slice(1)}`]
                        }
                    })
                }
            }
            if (model[apiName]) {
                field['default_value'] = model[apiName];
                delete model[apiName];
            }

            arr.push(field);
        });
        // 遍历聚合 字段依赖关系 _sorted_index

        let sortedArr = [];
        // 通过child_node 查找子field, 并插入数组
        let sortedField = function (node) {
            if (node._sorted || (node.parent_node && !node._child)) { // 已经插入 或者 存在父级但不是从父级遍历过来的
                return;
            }
            sortedArr.push(node);
            node._sorted = true;

            let childNode = node.child_node;
            if (childNode) {
                childNode.forEach((child, index) => {
                    child._child = true;
                    sortedField(child);
                });
            }
        };
        arr.forEach((item, index) => {
            sortedField(item);
        });

        // 2. 计算字段处理
        //  2.1 无计算公式，支付金额不变
        //  2.2 有计算公式，关联字段等变化时支付金额请求接口获取
        let payment_field = Object.values(fields).find((item) => {
            return item.group_type === 'payment' && item.type === 'currency';
        })
        let payment_data = {};
        let payment_obj = {};
        if (payment_field) {
            if (payment_field.default_is_expression) {
                let matchResult = payment_field.default_value.match(/\$[\w\_\.]+\$/g) || [];
                let payment_fields = matchResult.map((item) => {
                    return item.replace(/\$/g, '');
                });
                payment_fields.forEach((item) => {
                    let field = fields[item];
                    if (field) {
                        payment_data[item] = '';
                    };
                });
            };

            payment_obj = { [payment_field.api_name]: default_values[payment_field.api_name] };
        };


        this.setState({
            buttons,
            description: description,
            components: sortedArr,
            is_show_captcha,
            displayName,
            payment_obj,
            payment_data
        });
        document.title = displayName || $st('表单');
    }
    trimData = (data) => {
        for (let key in data) {
            if (typeof data[key] === 'string') {
                data[key] = data[key].trim();
            }
        }
    }
    onSubmit = (data) => {
        console.log(data);
        this.trimData(data);
        this.formatDateData(data);
        let is_show_captcha = this.state.is_show_captcha;

        let attachFlag = this.formatAttach(data);

        let params = {
            formData: Object.assign(data, model), // url里面参数，全部带回
            cardId: model.cardId
        }

        if (is_show_captcha) {
            params = Object.assign(params, data.verifyCode);
            delete data.verifyCode;
        }

        params.formData = JSON.stringify(params.formData);

        // 存在附件上传时，还需要比较表单里面是否存在验证码控件
        if (attachFlag && !is_show_captcha) {
            this.setState({
                verifyCode: {
                    callback: (data) => {
                        this.setState({
                            verifyCode: null
                        });
                        if (!data) { //取消，或者验证失败
                            return;
                        }
                        let { code, cid } = data || {};
                        params.verifyCode = code;
                        params.cid = cid;

                        this.submitForm(params);
                    }
                }
            })
        } else {
            this.submitForm(params);
        }
    }
    submitForm = (params) => {
        Toast.loading($st('paas.smart.form.submit'), 10);

        postData({
            url: "/smartform/rest/extApi/data/submit",
            data: JSON.stringify(params),
            callback: (response) => {
                Toast.hide();
                let { code, message, data = {} } = response;
                if (code === 0) {
                    let paymentUrl = data.paymentUrl;
                    if (paymentUrl) {
                        Toast.info($st('提交成功'), 2);
                        if (!isMobile) {
                            // 支付中...
                            let isPaying = true;

                            let qrCode = (<div className='qrcode'><p>请使用微信、支付宝支付<span className="amount"> ¥ {Object.values(this.state.payment_obj)[0]}</span></p><img src={jrQrcode.getQrBase64(paymentUrl)} alt={$st("支付二维码")} /></div>);
                            let alert = Modal.alert('扫码支付', qrCode, [{
                                text: $st('关闭'), onPress: () => {
                                    isPaying = false;
                                }
                            }]);

                            let me = this;
                            let entries = paymentUrl.split('?')[1].split('&');
                            let orderNo;
                            entries.forEach(item => {
                                let entry = item.split('=');
                                if (entry[0] === 'orderNo') {
                                    orderNo = entry[1];
                                };
                            })
                            function dealPayResult() {
                                getPayResult(JSON.stringify({
                                    enterpriseAccount: data.ea,
                                    orderNo: orderNo
                                }), (response) => {
                                    setTimeout(() => {
                                        // 订单完成
                                        if (response === 'FINISH_ORDER') {
                                            me.setState({
                                                submitResult: true,
                                                isPay: true
                                            })
                                            alert.close();
                                        } else {
                                            isPaying && dealPayResult();
                                        }
                                    }, 2000)
                                });
                            }

                            dealPayResult();
                        } else if (isMobileBrowser) {
                            this.setState({
                                submitResult: true
                            });
                        } else {
                            window.location.href = paymentUrl;
                        }
                    } else {
                        this.setState({
                            submitResult: true
                        })
                    }
                } else if (code === 304601012) {
                    Toast.info(message, 2);
                    this.setState({
                        submitResult: true
                    })
                } else {
                    Toast.info(message, 2);
                    this.setState({
                        is_show_captcha: false
                    })
                    this.setState({
                        is_show_captcha: true
                    })
                }
            },
            error: () => {
                Toast.hide();
            }
        });
    }

    getFileExt(fileName) {
        let index = fileName.lastIndexOf('.');
        return fileName.slice(index + 1)
    }
    //格式化文件上传数据
    formatAttach(formData) {
        let components = this.state.components;
        let fields = components.filter((field) => {
            return field.type === 'image' || field.type === 'signature' || field.type === 'file_attachment';
        });
        let flag = 0;
        fields.forEach((field) => {
            let tempData = formData[field.api_name];
            let data = [];
            if (tempData) {
                tempData.forEach((item) => {
                    if (field.type === 'signature') {
                        if (item.tempPath) {
                            data.push({
                                ext: this.getFileExt(item.name),
                                path: item.tempPath,
                                filename:item.name || '',
                                size:item.size || ''
                            });
                        }
                    } else {
                        flag++;
                        if (field.type === 'image') {
                            if (item.tempPath) {
                                data.push({
                                    ext: this.getFileExt(item.name),
                                    path: item.tempPath,
                                    filename:item.name || '',
                                    size:item.size || ''
                                });
                            }
                        } else {
                            if (item.tempPath) {
                                data.push({
                                    ext: this.getFileExt(item.name),
                                    path: item.tempPath,
                                    size: item.size,
                                    filename: item.name,
                                    create_time: +new Date()
                                });
                            }
                        }
                    }
                })
            }

            formData[field.api_name] = data;
        });
        return flag;
    }
    // 格式日期上传格式
    formatDateData(formData) {
        let components = this.state.components || [];
        let fields = components.filter((item) => {
            return item.type === 'date' || item.type === 'time' || item.type === 'date_time';
        });
        fields.forEach((item) => {
            let tempData = formData[item.api_name];
            formData[item.api_name] = tempData && (+tempData);
        });
    }
    componentWillUpdate(nextProps, nextState) {
        let { getFieldProps } = this.props.form;
        let { payment_obj, payment_data } = this.state;
        let data = {};

        if (Object.keys(payment_data).length === 0) return;

        for (let key in payment_data) {
            data[key] = getFieldProps(key).value || '';
        }

        if (JSON.stringify(payment_data) === JSON.stringify(data)) return;

        let value = {
            cardId: model.cardId,
            fieldApiName: Object.keys(payment_obj)[0],
            data: JSON.stringify(data)
        };
        this.setState({
            payment_data: data
        });

        calPaymentAmount(JSON.stringify(value), (response) => {
            this.setState({
                payment_obj: response.calculateResult
            });
        });
    }
    handleCountryChange = (country,apiname) => {
        this.setState(prevState => ({
            selectedCountry: {
                ...prevState.selectedCountry,
                [apiname]: country // 根据 apiname 更新对应的国家
            },
            selectedProvince: {
                ...prevState.selectedProvince,
                [apiname]: null // 清空对应的省份
            },
            selectedCity: {
                ...prevState.selectedCity,
                [apiname]: null // 清空对应的城市
            },
            selectedDistrict: {
                ...prevState.selectedDistrict,
                [apiname]: null // 清空对应的区
            }
        }));
        const { form } = this.props;
        form.setFieldsValue({
            // 使用 api_name 设置值
            [apiname]: country
        });
    }

    handleProvinceChange = (province,apiname) => {
        this.setState(prevState => ({
            selectedProvince: {
                ...prevState.selectedProvince,
                [apiname]: province // 根据 apiname 更新对应的省份
            },
            selectedCity: {
                ...prevState.selectedCity,
                [apiname]: null // 清空对应的城市
            },
            selectedDistrict: {
                ...prevState.selectedDistrict,
                [apiname]: null // 清空对应的区
            }
        }));
        const { form } = this.props;
        form.setFieldsValue({
            // 使用 api_name 设置值
            [apiname]: province
        });
    }

    handleCityChange = (city,apiname) => {
        this.setState(prevState => ({
            selectedCity: {
                ...prevState.selectedCity,
                [apiname]: city // 根据 apiname 更新对应的城市
            },
            selectedDistrict: {
                ...prevState.selectedDistrict,
                [apiname]: null // 清空对应的区
            }
        }));
        const { form } = this.props;
        form.setFieldsValue({
            // 使用 api_name 设置值
            [apiname]: city
        });
    }

    handleDistrictChange = (district,apiname) => {
        this.setState(prevState => ({
            selectedDistrict: {
                ...prevState.selectedDistrict,
                [apiname]: district // 根据 apiname 更新对应的区
            }
        }));
        const { form } = this.props;
        form.setFieldsValue({
            // 使用 api_name 设置值
            [apiname]: district
        });
    }

    fieldOnChange(val,apiname){
        // 这里可能需要更新表单值
        const { form } = this.props;
        form.setFieldsValue({
            // 使用 api_name 设置值
            [apiname]: val
        });
    }
    render() {
        let props = this.props;
        let form = props.form;
        let { error, message, buttons = [], description, displayName, components = [], submitResult, isPay, verifyCode, is_show_captcha, payment_obj,timeCode,isRenderLang,isOldAddress } = this.state;
        if(!isRenderLang){
            return (<div className='App' ref='App'></div>);
        }
        let errorEl = (<div className="error-message">{message}</div>);
        let componentsEl = components.map((item) => {
            let type = item.type;
            if(isOldAddress && ['country','province','city','district'].includes(type)){
                type = type + '_old';
            }
            let ComponentEle = TypeToComponent[type];
            if (ComponentEle) {
                switch(type) {
                    case 'country':
                        return (
                            <ComponentEle 
                                key={item.api_name} {...item} form={form}
                                onCountryChange={(val) => this.handleCountryChange(val, item.api_name)}
                            />
                        );
                    case 'province':
                        return (
                            <ComponentEle 
                                key={item.api_name} {...item} form={form}
                                countryId={this.state.selectedCountry}
                                onProvinceChange={(val) => this.handleProvinceChange(val, item.api_name)}
                            />
                        );
                    case 'city':
                        return (
                            <ComponentEle 
                                key={item.api_name} {...item} form={form}
                                countryId={this.state.selectedCountry}
                                provinceId={this.state.selectedProvince}
                                onCityChange={(val) => this.handleCityChange(val, item.api_name)}
                            />
                        );
                    case 'district':
                        return (
                            <ComponentEle 
                                key={item.api_name} {...item} form={form}
                                cityId={this.state.selectedCity}
                                countryId={this.state.selectedCountry}
                                provinceId={this.state.selectedProvince}
                                onDistrictChange={(val) => this.handleDistrictChange(val, item.api_name)}
                            />
                        );
                    default:
                        return (<ComponentEle key={item.api_name} {...item} form={form} onChange={(val) => this.fieldOnChange(val, item.api_name)} />);
                }
                
            } else {
                return null;
            }
        });

        let titleEl = (<div>
            <WhiteSpace size="lg" />
            <div className="form-title">{displayName}</div>
            <WhiteSpace size="lg" />
        </div>);
        let descriptionEl = (<WingBlank>
            <WhiteSpace size="xl" />
            <div className="form-description">{description}</div>
            <WhiteSpace size="lg" />
        </WingBlank>);

        let payment_amount = +Object.values(payment_obj)[0] || 0;
        let buttonsEl = buttons.map((item) => {
            return (<ButtonEl key={item.api_name} {...item} submitForm={this.onSubmit} form={form} payment_amount={payment_amount} />);
        });

        buttonsEl = (
            <div className="form-buttons">
                {buttonsEl}
            </div>
        );
        if (submitResult) {
            let msg = isPay ? $st('付款成功') : $st('提交成功');
            return (<div className='App'><SubmitResult message={msg} /></div>);
        }

        if (error) {
            return (<div className='App'> {errorEl}</div>);
        } else {
            let codeProps = {
                api_name: 'verifyCode',
                label: $st('验证码'),
                is_required: true
            };

            return (
                <div className='App' ref='App'>
                    {titleEl}
                    {description && descriptionEl}
                    {isMobileBrowser && (payment_amount > 0) && <div>
                        <WhiteSpace size="xl" />
                        <NoticeBar mode="closable" action={<span style={{ color: '#a1a1a1' }}>{$st("不再提示")}</span>}>
                            {$st("手机浏览器只能提交表单，无法进行支付")}
                            </NoticeBar>
                        <WhiteSpace size="xl" />
                    </div>}
                    <List className='list-wrap'>
                        {componentsEl}
                    </List>
                    {is_show_captcha && <ImageCode form={form} {...codeProps} key={timeCode}/>}
                    <WhiteSpace size='xl' />
                    {buttonsEl}
                    <WhiteSpace size='xl' />
                    {verifyCode && <ImageCodeModal {...verifyCode}></ImageCodeModal>}
                </div>
            )
        }
    }
}

export default createDOMForm()(App);



// WEBPACK FOOTER //
// ./src/App.js